(function (Translator) {
    // et
    Translator.add("theme.dropzone.drop-files-here", "\u00dcleslaadimiseks lohista failid siia", "DropZone", "et");
    Translator.add("theme.dropzone.max-file-size", "Maksimaalne faili suurus on %maxFileSize%", "DropZone", "et");
    Translator.add("theme.dropzone.max-number-of-files", "Maksimaalne failide arv on %maxNumberOfFiles%", "DropZone", "et");
    Translator.add("theme.dropzone.not_allowed_file_mime_type", "See fail ei luba MIME t\u00fc\u00fcpi", "DropZone", "et");
    Translator.add("theme.dropzone.or", "v\u00f5i", "DropZone", "et");
    Translator.add("theme.dropzone.overall-max-file-size", "Faili kogu suurus on %maxFilesSize%", "DropZone", "et");
    Translator.add("theme.dropzone.select_file", "Vali fail", "DropZone", "et");
    Translator.add("theme.dropzone.selected_files", "Imporditud kehtivad failid", "DropZone", "et");
    Translator.add("theme.dropzone.selected_files_with_errors", "Kehtetud failid", "DropZone", "et");
    Translator.add("theme.dropzone.selected_transfer_serial_number_in_file", "Teisaldage number failis", "DropZone", "et");
    Translator.add("theme.dropzone.too_big_file", "See fail on importimiseks liiga suur", "DropZone", "et");
})(Translator);
